
import { SelectOption } from '@/shared/components/DynamicForm/models/DynamicFieldData'
import { SelectEditCell } from '@/shared/components/GridTable/GridCells/SelectEditCell'
import { GridColDef } from '@mui/x-data-grid-premium'

export const manageDriversDialogColumnDefs: GridColDef[] = [
  {
    field: 'description',
    headerName: 'Run Description',
    width: 100,
  },
  {
    field: 'plannedStartTime',
    headerName: 'Start Time',
    width: 100,
  },
  {
    field: 'estimatedFinishTime',
    headerName: 'End Time',
    width: 100,
  },
  {
    field: 'shiftDuration',
    headerName: 'Shift Duration',
    width: 100,
  },
  {
    field: 'orderCount',
    headerName: '#Jobs',
    width: 70,
  },
  {
    field: 'driver',
    headerName: 'Driver',
    editable: true,
    width: 180,
  },
]

export const getManagerDriversDialogColumnDefs = (driverOptions: SelectOption[]) => {
  // update the driver column with the driverOptions
  const driverColumns = manageDriversDialogColumnDefs.map(colDef => {
    if (colDef.field === 'driver') {
      colDef.renderEditCell = (params) => (
        <SelectEditCell
          {...params}
          options={driverOptions}
          placeholder="Select Driver"
          required
        />
      )

      colDef.valueFormatter = (value) => {
        const driver = driverOptions.find(driv => driv.value === value)

        return driver ? driver.label : ''
      }
    }

    return colDef
  })

  return driverColumns
}